import React from 'react';

export const ArrowOutgoingIcon = ({ fill='none', width='20', height='20', className='' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M14.2946 6.85236L6.34844 14.7908C6.23766 14.9016 6.11844 14.9524 5.99076 14.9432C5.86306 14.9339 5.74384 14.8739 5.63308 14.7632C5.5223 14.6524 5.46692 14.5311 5.46692 14.3993C5.46692 14.2675 5.5223 14.1463 5.63308 14.0355L13.5516 6.1093L6.6546 6.1093C6.50727 6.1093 6.38377 6.05984 6.2841 5.96094C6.18445 5.86203 6.13462 5.73947 6.13462 5.59326C6.13462 5.44704 6.18445 5.32317 6.2841 5.22164C6.38377 5.1201 6.50727 5.06934 6.6546 5.06934L14.6915 5.06934C14.8737 5.06934 15.0264 5.13096 15.1497 5.25422C15.273 5.37747 15.3346 5.5302 15.3346 5.7124L15.3346 13.7493C15.3346 13.8967 15.2851 14.0201 15.1862 14.1198C15.0873 14.2195 14.9648 14.2693 14.8185 14.2693C14.6723 14.2693 14.5485 14.2195 14.4469 14.1198C14.3454 14.0201 14.2946 13.8967 14.2946 13.7493L14.2946 6.85236Z" 
fill={fill}/>
</svg>


    );
};

export default ArrowOutgoingIcon;
